import React from 'react';
import { Text } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import { FeaturedMatch } from '../components/FeaturedMatch';
import {
  BoxHeadingWrapper,
  FlexIllustrationWrapper,
  FlexWrapper,
  TextHeading,
  TextSubHeading,
} from '../styles/Featured.styles';
import baseTemplate from './template.default';

const template: TTemplate = {
  wrapper: <FlexWrapper />,
  slogan: {
    body: (
      <BoxHeadingWrapper>
        <TextHeading>
          Bend <Text as="span">it</Text>
        </TextHeading>
        <TextSubHeading>
          {String(`'Round the belt!`)
            .split('')
            .map((l) => (
              <Text as="span" key={`featured-sport-${l}`}>
                {l}
              </Text>
            ))}
        </TextSubHeading>
      </BoxHeadingWrapper>
    ),
    feature: <FeaturedMatch />,
  },
  mascot: <FlexIllustrationWrapper />,

  ...(baseTemplate?.first as TTemplate),
};

export default template;
